/* eslint-disable */
/**
 * This file was automatically generated by GraphQL Code Generator.
 * Do not make changes to this file as they will be lost when the code is regenerated.
 */

import {
  AchievementGroup,
  AchievementType,
  AdapterType,
  AppListingStore,
  AssetStatus,
  AudioAnchor,
  AudioTextNormalization,
  AutoReloadIneligibilityReason,
  AutoReloadState,
  AutoTrainingIneligibilityReason,
  AutoTrainingType,
  BillingPeriod,
  BlueprintInputObjectType,
  BlueprintObjectType,
  BlueprintRunStatus,
  BlueprintValidationErrorCode,
  BlueprintValueReferenceType,
  BlueprintVersionStatus,
  CanvasObjectType,
  ConsentStatus,
  CreativeUnitTransferType,
  ErrorType,
  EventName,
  EventResourceType,
  EventType,
  ExportAssetFormat,
  ExportCompressionLevel,
  ExportFileFormat,
  ExportVideoCodec,
  FileContentCategory,
  FileExportStatus,
  FileRefinementType,
  FileReportType,
  FileStatus,
  GenerationRunStatus,
  GenerationType,
  GetBlueprintRunStepIdType,
  GetWorkspaceBlueprintsInputScope,
  GetWorkspaceStyleInputIdType,
  GoogleDriveKind,
  GoogleDriveObjectTypeFilter,
  GroupManagedBy,
  GuardrailAction,
  GuidanceFileType,
  InferenceErrorCode,
  InferenceQuality,
  InferenceStatus,
  InputGuardrailKind,
  Intent,
  LabelStatus,
  LibraryObjectStatus,
  LibraryObjectTypeFilter,
  LibraryScope,
  LoginStrategy,
  Modality,
  ObjectVisibility,
  OnBlueprintExecutionEventInputIdType,
  OnInferenceProgressInputIdType,
  OnTrainingRunProgressInputIdType,
  OnboardingCompletionSource,
  OnboardingUserType,
  PackageType,
  PayoutAccountStatus,
  PlanTier,
  PolicyScoreBand,
  PoseMode,
  PreprocessImageAnnotator,
  ProjectIntegrationTargetKind,
  ProjectObjectLinkStatus,
  ProjectObjectLinkType,
  ProjectObjectTypeFilter,
  ProjectStatus,
  PushProvider,
  ReferenceSetCompatibilityTag,
  RewardProgram,
  RewardStatus,
  RoleStatus,
  ScoringRunMode,
  SearchBaseModelsSort,
  SearchBlueprintsSort,
  SearchEntityType,
  SearchFacetKind,
  SearchFilesSort,
  SearchLibraryScope,
  SearchProjectsScope,
  SearchProjectsSort,
  SearchReferenceSetsSort,
  SearchSessionsScope,
  SegmentLevel,
  SegmentTarget,
  SessionCanvasObjectEventType,
  SessionFormType,
  SessionInferenceMode,
  SessionObjectEventType,
  SessionObjectTypeFilter,
  SessionStatus,
  SessionTemplateExploreSection,
  SessionTemplateStatus,
  ShortcutTargetType,
  SkillAgent,
  SkillImportDropCode,
  SkillLoadingMode,
  SkillResourceKind,
  SkillScopeSource,
  SkillStatus,
  SortingDirection,
  SourceType,
  SsoConnectionStatus,
  SsoConnectionStrategy,
  StyleAutoPopulationAttribute,
  StyleCanForgeFromStatus,
  StyleCategory,
  StyleContentType,
  StyleFinetuneStatus,
  StyleInputFileType,
  StyleStatus,
  StyleType,
  StyleTypeFilter,
  ThinkingLevel,
  TrainingCategory,
  TrainingFramework,
  TrainingMethod,
  TrainingRunStatus,
  UsageLimitPeriod,
  UsageLimitStatus,
  VectorizationColorMode,
  VectorizationMode,
  VideoCodec,
  VideoEffectType,
  WorkspaceDomainStatus,
  WorkspaceIntegrationProvider,
  WorkspaceIntegrationScopeTargetKind,
  WorkspaceIntegrationStatus,
  WorkspaceMembershipStatus,
  WorkspaceRole,
  WorkspaceUsageGroupBy,
} from "./schema.graphql.d";
export const ACHIEVEMENT_GROUP: AchievementGroup[] = [
  "GRID",
  "INVITE",
  "JOURNEY",
  "ONGOING",
];
export const ACHIEVEMENT_TYPE: AchievementType[] = [
  "BOOLEAN",
  "COUNT",
  "SUM",
  "TIERED",
];
export const ADAPTER_TYPE: AdapterType[] = ["LORA", "VOICE_EMBEDDING"];
export const APP_LISTING_STORE: AppListingStore[] = [
  "APP_STORE",
  "PLAY_STORE",
  "STEAM",
];
export const ASSET_STATUS: AssetStatus[] = ["ACTIVE", "ARCHIVED", "DELETED"];
export const AUDIO_ANCHOR: AudioAnchor[] = ["END", "START"];
export const AUDIO_TEXT_NORMALIZATION: AudioTextNormalization[] = [
  "AUTO",
  "OFF",
  "ON",
];
export const AUTO_RELOAD_INELIGIBILITY_REASON: AutoReloadIneligibilityReason[] =
  [
    "CHILD_WORKSPACE",
    "ENTERPRISE_PLAN",
    "INSUFFICIENT_PERMISSION",
    "NO_PAYMENT_METHOD",
  ];
export const AUTO_RELOAD_STATE: AutoReloadState[] = [
  "ARMED",
  "CHARGED",
  "CHARGING",
  "FAILED",
  "NEEDS_ACTION",
  "NEEDS_ATTENTION",
];
export const AUTO_TRAINING_INELIGIBILITY_REASON: AutoTrainingIneligibilityReason[] =
  ["NOT_ENOUGH_IMAGES", "NO_ALLOWED_BASE_MODEL"];
export const AUTO_TRAINING_TYPE: AutoTrainingType[] = [
  "IMAGE_EDIT",
  "TEXT_TO_IMAGE",
];
export const BILLING_PERIOD: BillingPeriod[] = ["MONTH", "YEAR"];
export const BLUEPRINT_INPUT_OBJECT_TYPE: BlueprintInputObjectType[] = [
  "INPUT",
  "NODE",
];
export const BLUEPRINT_OBJECT_TYPE: BlueprintObjectType[] = [
  "EDGE",
  "INPUT",
  "NODE",
  "OUTPUT",
];
export const BLUEPRINT_RUN_STATUS: BlueprintRunStatus[] = [
  "CANCELLED",
  "FAILURE",
  "PAUSED",
  "PENDING",
  "RUNNING",
  "SUCCESS",
];
export const BLUEPRINT_VALIDATION_ERROR_CODE: BlueprintValidationErrorCode[] = [
  "CIRCULAR_REFERENCE",
  "DISCONNECTED_GRAPH",
  "EMPTY_GRAPH",
  "INCOMPATIBLE_TYPES",
  "INVALID_INPUT",
  "INVALID_REFERENCE",
  "UNSATISFIED_INPUT",
];
export const BLUEPRINT_VALUE_REFERENCE_TYPE: BlueprintValueReferenceType[] = [
  "BLUEPRINT_PARAMETER",
  "NODE_PORT",
];
export const BLUEPRINT_VERSION_STATUS: BlueprintVersionStatus[] = [
  "ARCHIVED",
  "DRAFT",
  "PUBLISHED",
];
export const CANVAS_OBJECT_TYPE: CanvasObjectType[] = [
  "BLUEPRINT",
  "BLUEPRINT_RUN",
  "GROUP",
  "LIBRARY_OBJECT",
  "TEXT",
  "TIMELINE",
  "TREND",
];
export const CONSENT_STATUS: ConsentStatus[] = [
  "ACCEPTED",
  "NOT_SET",
  "REFUSED",
];
export const CREATIVE_UNIT_TRANSFER_TYPE: CreativeUnitTransferType[] = [
  "AUTO",
  "MANUAL",
];
export const ERROR_TYPE: ErrorType[] = [
  "BAD_REQUEST_ERROR",
  "FORBIDDEN_ERROR",
  "INTERNAL_SERVER_ERROR",
  "NOT_FOUND_ERROR",
  "PAYMENT_REQUIRED_ERROR",
  "RATE_LIMITED_ERROR",
  "UNAUTHORIZED_ERROR",
];
export const EVENT_NAME: EventName[] = [
  "ACHIEVEMENT_CLAIMED",
  "ACHIEVEMENT_EARNED",
  "ASSET_CREATED",
  "ASSET_DELETED",
  "ASSET_DUPLICATED",
  "ASSET_EXPORTED",
  "ASSET_FEATURED_IN_STYLE",
  "ASSET_FORGED",
  "ASSET_MOVED",
  "ASSET_POSTED_TO_STYLE",
  "ASSET_REFINED",
  "ASSET_RENAMED",
  "ASSET_UPDATED",
  "BILLING_PURCHASE_COMPLETED",
  "BLUEPRINT_ADDED_TO_WORKSPACE",
  "BLUEPRINT_CREATED",
  "BLUEPRINT_DELETED",
  "BLUEPRINT_PUBLISHED",
  "BLUEPRINT_REMOVED_FROM_WORKSPACE",
  "BLUEPRINT_RUN_FINISHED",
  "BLUEPRINT_UPDATED",
  "CHAT_FEEDBACK_SUBMITTED",
  "COMMENT_ADDED",
  "COMMENT_DELETED",
  "COMMENT_REACTION_ADDED",
  "COMMENT_REACTION_REMOVED",
  "COMMENT_THREAD_CREATED",
  "COMMENT_THREAD_DELETED",
  "COMMENT_THREAD_RESOLVED",
  "COMMENT_THREAD_UNRESOLVED",
  "DIRECTORY_CREATED",
  "DIRECTORY_DELETED",
  "DIRECTORY_MOVED",
  "DIRECTORY_UPDATED",
  "FILES_EXPORTED",
  "FILES_ZIPPED",
  "FILE_DELETED",
  "FILE_LIKED",
  "FILE_MOVED",
  "FILE_REPORTED",
  "FILE_UNLIKED",
  "FILE_UPDATED",
  "FILE_UPLOADED",
  "GENERATION_FEEDBACK_SUBMITTED",
  "GOOGLE_DRIVE_FILES_IMPORTED",
  "LABEL_ARCHIVED",
  "LABEL_UNARCHIVED",
  "OBJECT_INTERACTED",
  "PROJECT_ARCHIVED",
  "PROJECT_CREATED",
  "PROJECT_DELETED",
  "PROJECT_MEMBER_ADDED",
  "PROJECT_MEMBER_REMOVED",
  "PROJECT_OBJECT_LINKED",
  "PROJECT_OBJECT_UNLINKED",
  "PROJECT_SESSION_LINKED",
  "PROJECT_UNARCHIVED",
  "REFERENCE_SET_CREATED",
  "REFERENCE_SET_DUPLICATED",
  "REFERENCE_SET_REFERENCED_IN_GENERATION",
  "REWARD_CLAIMED",
  "REWARD_EARNED",
  "SESSION_ARCHIVED",
  "SESSION_CREATED",
  "SESSION_DELETED",
  "SESSION_INTERACTED",
  "SESSION_UNARCHIVED",
  "SESSION_UPDATED",
  "SHORTCUT_CREATED",
  "SHORTCUT_DELETED",
  "SHORTCUT_UPDATED",
  "SKILL_CREATED",
  "SKILL_DELETED",
  "SKILL_UPDATED",
  "STYLE_ACTIVE_FINETUNE_SET",
  "STYLE_ADDED_TO_WORKSPACE",
  "STYLE_ARCHIVED",
  "STYLE_CREATED",
  "STYLE_DELETED",
  "STYLE_DUPLICATED",
  "STYLE_LIKED",
  "STYLE_MOVED",
  "STYLE_REMOVED_FROM_WORKSPACE",
  "STYLE_TRAINING_CANCELLED",
  "STYLE_TRAINING_COMPLETED",
  "STYLE_TRAINING_FAILED",
  "STYLE_TRAINING_STARTED",
  "STYLE_UNARCHIVED",
  "STYLE_UPDATED",
  "SUBSCRIPTION_CANCELLED",
  "TREND_CREATED",
  "TREND_DELETED",
  "TREND_UPDATED",
  "UNITS_CONSUMED",
  "USER_ACTIVATED",
  "USER_ACTIVE_WORKSPACE_SET",
  "USER_CREATED",
  "USER_DELETED",
  "USER_INVITED",
  "USER_ROLE_UPDATED",
  "USER_SUSPENDED",
  "USER_UPDATED",
  "VIDEO_TIMELINE_CREATED",
  "VIDEO_TIMELINE_RENDER_FINISHED",
  "VIDEO_TIMELINE_RENDER_LAUNCHED",
  "WORKSPACE_AUTO_RELOAD_UPDATED",
  "WORKSPACE_BILLING_LINK_CREATED",
  "WORKSPACE_BILLING_UPDATED",
  "WORKSPACE_CREATED",
  "WORKSPACE_DELETED",
  "WORKSPACE_GROUP_MEMBERSHIP_CREATED",
  "WORKSPACE_GROUP_MEMBERSHIP_UPDATED",
  "WORKSPACE_INTEGRATION_CREATED",
  "WORKSPACE_INTEGRATION_DELETED",
  "WORKSPACE_INTEGRATION_SCOPE_CLEARED",
  "WORKSPACE_INTEGRATION_SCOPE_SET",
  "WORKSPACE_METERED_BILLING_CHECKOUT_LINK_CREATED",
  "WORKSPACE_METERED_BILLING_PORTAL_LINK_CREATED",
  "WORKSPACE_PAYOUT_DASHBOARD_LINK_CREATED",
  "WORKSPACE_PAYOUT_ONBOARDING_LINK_CREATED",
  "WORKSPACE_SEAT_COUNT_UPDATED",
  "WORKSPACE_UPDATED",
];
export const EVENT_RESOURCE_TYPE: EventResourceType[] = [
  "ACHIEVEMENT",
  "BLUEPRINT",
  "CANVAS",
  "COMMENT",
  "COMMENT_THREAD",
  "DIRECTORY",
  "FILE",
  "INFERENCE",
  "LABEL",
  "PROJECT",
  "REWARD",
  "SESSION",
  "SHORTCUT",
  "SKILL",
  "STYLE",
  "TREND",
  "USAGE",
  "USER",
  "WORKSPACE",
  "WORKSPACE_INTEGRATION",
  "WORKSPACE_MEMBERSHIP",
];
export const EVENT_TYPE: EventType[] = [
  "ACHIEVEMENT",
  "ASSET",
  "BLUEPRINT",
  "COMMENT",
  "DIRECTORY",
  "FILE",
  "LABEL",
  "LIBRARY_OBJECT",
  "PROJECT",
  "REWARD",
  "SESSION",
  "SHORTCUT",
  "SKILL",
  "STYLE",
  "TREND",
  "USAGE",
  "USER",
  "WORKSPACE",
];
export const EXPORT_ASSET_FORMAT: ExportAssetFormat[] = ["PSD", "ZIP"];
export const EXPORT_COMPRESSION_LEVEL: ExportCompressionLevel[] = [
  "HIGH",
  "NORMAL",
];
export const EXPORT_FILE_FORMAT: ExportFileFormat[] = [
  "GIF",
  "GLTF",
  "JPEG",
  "MOV",
  "MP4",
  "OBJ",
  "PNG",
  "PSD",
  "WEBM",
];
export const EXPORT_VIDEO_CODEC: ExportVideoCodec[] = ["H264", "H265"];
export const FILE_CONTENT_CATEGORY: FileContentCategory[] = [
  "AUDIO",
  "FONT",
  "IMAGE",
  "MESH",
  "OTHER",
  "PLAYABLE",
  "POSE",
  "SAFETENSORS",
  "SPINE",
  "VIDEO",
];
export const FILE_EXPORT_STATUS: FileExportStatus[] = [
  "CANCELLED",
  "COMPLETED",
  "EXPIRED",
  "FAILED",
  "PENDING",
  "PROCESSING",
];
export const FILE_REFINEMENT_TYPE: FileRefinementType[] = [
  "CROP",
  "EXPAND",
  "ORIGINAL",
  "REMOVE_BACKGROUND",
  "REMOVE_OBJECTS",
  "SEGMENTATION",
  "UPSCALE_ESRGAN",
  "UPSCALE_ESRGAN_FACE_CORRECTION",
  "UPSCALE_STYLE",
];
export const FILE_REPORT_TYPE: FileReportType[] = [
  "BAD_QUALITY",
  "HATE_SPEECH",
  "IP_INFRINGEMENT",
  "NUDITY",
  "OTHER",
  "SPAM",
  "VIOLENCE",
];
export const FILE_STATUS: FileStatus[] = [
  "DELETED",
  "FAILED_PROCESSING",
  "PENDING",
  "PROCESSED",
  "UPLOADED",
];
export const GENERATION_RUN_STATUS: GenerationRunStatus[] = [
  "CANCELLED",
  "COMPLETE",
  "FAILED",
  "PENDING",
  "RUNNING",
];
export const GENERATION_TYPE: GenerationType[] = [
  "ANIMATE_MESH",
  "BLUEPRINT",
  "CREATE",
  "EDIT",
  "IMAGE_TO_3D",
  "IMAGE_TO_VIDEO",
  "LIP_SYNC",
  "REALTIME",
  "REFILL",
  "REMOVE_BACKGROUND",
  "SOUND_EFFECT",
  "TEXT_TO_3D",
  "TEXT_TO_SPEECH",
  "UPSCALE",
  "UPSCALE_VIDEO",
  "VECTORIZE_IMAGE",
];
export const GET_BLUEPRINT_RUN_STEP_ID_TYPE: GetBlueprintRunStepIdType[] = [
  "NODE_ID",
  "STEP_ID",
];
export const GET_WORKSPACE_BLUEPRINTS_INPUT_SCOPE: GetWorkspaceBlueprintsInputScope[] =
  ["ALL", "DISCOVERY", "EXECUTION"];
export const GET_WORKSPACE_STYLE_INPUT_ID_TYPE: GetWorkspaceStyleInputIdType[] =
  ["ID", "SLUG"];
export const GOOGLE_DRIVE_KIND: GoogleDriveKind[] = [
  "MY_DRIVE",
  "SHARED_DRIVE",
];
export const GOOGLE_DRIVE_OBJECT_TYPE_FILTER: GoogleDriveObjectTypeFilter[] = [
  "FILE",
  "FOLDER",
];
export const GROUP_MANAGED_BY: GroupManagedBy[] = ["MANUAL", "SCIM"];
export const GUARDRAIL_ACTION: GuardrailAction[] = ["BLOCK", "WARN"];
export const GUIDANCE_FILE_TYPE: GuidanceFileType[] = [
  "AUDIO",
  "CANNY",
  "COLOR_SKETCH",
  "DEPTH",
  "EDITING_REFERENCE",
  "ELEMENT_FRONTAL_IMAGE",
  "ELEMENT_REFERENCE_IMAGE",
  "ELEMENT_VIDEO",
  "FACE",
  "FIRST_FRAME",
  "INIT",
  "INIT_AUDIO",
  "INIT_IMAGE",
  "INIT_MESH",
  "INIT_VIDEO",
  "IP_ADAPTER",
  "LAST_FRAME",
  "LINEART",
  "POSE",
  "PROMPT",
  "REFERENCE_AUDIO",
  "REFERENCE_IMAGE",
  "REFERENCE_VIDEO",
  "SCRIBBLE",
  "SEGMENTATION",
  "SOFTEDGE_HED",
  "TEXTURE_IMAGE",
];
export const INFERENCE_ERROR_CODE: InferenceErrorCode[] = [
  "BALANCE_UNAVAILABLE",
  "CONTENT_POLICY_VIOLATION",
  "DOWNSTREAM_SERVICE_CLIENT_ERROR",
  "DOWNSTREAM_SERVICE_ERROR",
  "DOWNSTREAM_SERVICE_SERVER_ERROR",
  "IMAGE_TOO_LARGE",
  "IMAGE_TOO_SMALL",
  "INPUT_GUARDRAIL_VIOLATION",
  "INSUFFICIENT_BALANCE",
  "INTERNAL_SERVER_ERROR",
  "INVALID_IMAGE_SIZE",
  "INVALID_INPUTS_ERROR",
  "MODEL_CAPABILITY_MISMATCH",
  "NO_MEDIA_GENERATED",
  "PROMPT_INTELLECTUAL_PROPERTY",
  "VIDEO_TOO_LARGE",
  "VIDEO_TOO_LONG",
  "VIDEO_TOO_SHORT",
  "VIDEO_TOO_SMALL",
];
export const INFERENCE_QUALITY: InferenceQuality[] = ["HIGH", "LOW", "MEDIUM"];
export const INFERENCE_STATUS: InferenceStatus[] = [
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "IN_PROGRESS",
];
export const INPUT_GUARDRAIL_KIND: InputGuardrailKind[] = [
  "ARTIST_STYLE_MIMICRY",
  "COPYRIGHT_INFRINGEMENT",
  "IP_TRADEMARK_INFRINGEMENT",
];
export const INTENT: Intent[] = ["EXPORT_ASSET"];
export const LABEL_STATUS: LabelStatus[] = ["ACTIVE", "ARCHIVED"];
export const LIBRARY_OBJECT_STATUS: LibraryObjectStatus[] = [
  "DRAFT",
  "FAILED",
  "PROCESSING",
  "READY",
];
export const LIBRARY_OBJECT_TYPE_FILTER: LibraryObjectTypeFilter[] = [
  "ASSET",
  "FILE",
  "REFERENCE_SET",
  "SKILL",
  "STYLE",
];
export const LIBRARY_SCOPE: LibraryScope[] = [
  "FEATURED",
  "SHARED",
  "WORKSPACE",
];
export const LOGIN_STRATEGY: LoginStrategy[] = [
  "APPLE",
  "EMAIL_OTP",
  "EMAIL_PASSWORD",
  "GOOGLE",
  "MICROSOFT_ENTRA",
  "OKTA",
  "TWITTER",
];
export const MODALITY: Modality[] = [
  "AUDIO",
  "IMAGE",
  "PLAYABLE",
  "TEXT",
  "THREE_D",
  "VIDEO",
];
export const OBJECT_VISIBILITY: ObjectVisibility[] = ["PRIVATE", "PUBLIC"];
export const ON_BLUEPRINT_EXECUTION_EVENT_INPUT_ID_TYPE: OnBlueprintExecutionEventInputIdType[] =
  ["BLUEPRINT_RUN", "BLUEPRINT_VERSION", "SESSION"];
export const ON_INFERENCE_PROGRESS_INPUT_ID_TYPE: OnInferenceProgressInputIdType[] =
  ["ASSET", "SESSION", "WORKSPACE"];
export const ON_TRAINING_RUN_PROGRESS_INPUT_ID_TYPE: OnTrainingRunProgressInputIdType[] =
  ["STYLE", "TRAINING_RUN"];
export const ONBOARDING_COMPLETION_SOURCE: OnboardingCompletionSource[] = [
  "COMPLETED",
  "SKIPPED",
];
export const ONBOARDING_USER_TYPE: OnboardingUserType[] = [
  "EXPLORER",
  "GAME_ARTIST",
  "NON_ARTIST",
  "OTHER",
];
export const PACKAGE_TYPE: PackageType[] = ["ONE_TIME", "SUBSCRIPTION"];
export const PAYOUT_ACCOUNT_STATUS: PayoutAccountStatus[] = [
  "ACTIVE",
  "NOT_STARTED",
  "ONBOARDING_INCOMPLETE",
  "RESTRICTED",
];
export const PLAN_TIER: PlanTier[] = ["ENTERPRISE", "FREE", "PRO", "STUDIO"];
export const POLICY_SCORE_BAND: PolicyScoreBand[] = [
  "GOOD",
  "MIDDLING",
  "POOR",
  "UNSCORED",
];
export const POSE_MODE: PoseMode[] = ["A_POSE", "T_POSE"];
export const PREPROCESS_IMAGE_ANNOTATOR: PreprocessImageAnnotator[] = [
  "CANNY",
  "DEPTH",
  "LINEART",
];
export const PROJECT_INTEGRATION_TARGET_KIND: ProjectIntegrationTargetKind[] = [
  "APPLOVIN_APP",
  "CONNECTION",
  "DRIVE_FOLDER",
  "MIRO_BOARD",
];
export const PROJECT_OBJECT_LINK_STATUS: ProjectObjectLinkStatus[] = [
  "ACTIVE",
  "DELETED",
];
export const PROJECT_OBJECT_LINK_TYPE: ProjectObjectLinkType[] = [
  "LIBRARY_OBJECT",
  "TREND",
];
export const PROJECT_OBJECT_TYPE_FILTER: ProjectObjectTypeFilter[] = [
  "ASSET",
  "BLUEPRINT",
  "DIRECTORY",
  "FILE",
  "REFERENCE_SET",
  "SKILL",
  "STYLE",
  "TREND",
];
export const PROJECT_STATUS: ProjectStatus[] = [
  "ACTIVE",
  "ARCHIVED",
  "DELETED",
];
export const PUSH_PROVIDER: PushProvider[] = ["APNS", "FCM"];
export const REFERENCE_SET_COMPATIBILITY_TAG: ReferenceSetCompatibilityTag[] = [
  "ANIMATION",
  "IMAGE_STYLE",
  "LORA",
  "NONE",
  "PROMPT_ONLY",
  "REFERENCES",
  "VOICE",
];
export const REWARD_PROGRAM: RewardProgram[] = [
  "ADMIN",
  "CREATOR",
  "ENTERPRISE_REFERRAL",
  "PARTNER",
  "REFERRAL",
  "WELCOME_BONUS",
];
export const REWARD_STATUS: RewardStatus[] = [
  "AWAITING_REVIEW",
  "CANCELLED_BEFORE_CLAIM",
  "CLAIMABLE",
  "CLAIMED",
  "REJECTED",
  "REVOCATION_PENDING",
  "REVOKED",
];
export const ROLE_STATUS: RoleStatus[] = ["ACTIVE", "ARCHIVED"];
export const SCORING_RUN_MODE: ScoringRunMode[] = ["ALWAYS", "ON_DEMAND"];
export const SEARCH_BASE_MODELS_SORT: SearchBaseModelsSort[] = [
  "NAME",
  "NEWEST",
  "POPULARITY",
  "RATING",
  "RELEVANCE",
];
export const SEARCH_BLUEPRINTS_SORT: SearchBlueprintsSort[] = [
  "CREATED_AT",
  "NAME",
  "RELEVANCE",
  "UPDATED_AT",
];
export const SEARCH_ENTITY_TYPE: SearchEntityType[] = [
  "BASE_MODEL",
  "BLUEPRINT",
  "FILE",
  "PROJECT",
  "REFERENCE_SET",
  "SESSION",
];
export const SEARCH_FACET_KIND: SearchFacetKind[] = [
  "BOOLEAN",
  "MULTI_SELECT",
  "SINGLE_SELECT",
];
export const SEARCH_FILES_SORT: SearchFilesSort[] = [
  "CREATED_AT",
  "NAME",
  "RECENTLY_USED",
  "RELEVANCE",
];
export const SEARCH_LIBRARY_SCOPE: SearchLibraryScope[] = [
  "FEATURED",
  "WORKSPACE",
];
export const SEARCH_PROJECTS_SCOPE: SearchProjectsScope[] = [
  "ALL",
  "ARCHIVED",
  "MINE",
];
export const SEARCH_PROJECTS_SORT: SearchProjectsSort[] = [
  "CREATED_AT",
  "NAME",
  "RELEVANCE",
  "UPDATED_AT",
];
export const SEARCH_REFERENCE_SETS_SORT: SearchReferenceSetsSort[] = [
  "CREATED_AT",
  "NAME",
  "RELEVANCE",
  "UPDATED_AT",
];
export const SEARCH_SESSIONS_SCOPE: SearchSessionsScope[] = ["ALL", "ARCHIVED"];
export const SEGMENT_LEVEL: SegmentLevel[] = ["HIGH", "LOW", "MEDIUM"];
export const SEGMENT_TARGET: SegmentTarget[] = ["CHARACTER", "GENERAL"];
export const SESSION_CANVAS_OBJECT_EVENT_TYPE: SessionCanvasObjectEventType[] =
  ["CREATED", "DELETED", "UPDATED"];
export const SESSION_FORM_TYPE: SessionFormType[] = [
  "AUDIO",
  "BLUEPRINT",
  "IMAGE",
  "PLAYABLE",
  "THREE_D",
  "VIDEO",
];
export const SESSION_INFERENCE_MODE: SessionInferenceMode[] = [
  "ADD_SFX_VIDEO",
  "ANIMATE_MESH",
  "BLUEPRINT",
  "CANVAS_2_D",
  "CANVAS_PROMPT_EDIT",
  "CREATE",
  "CREATE_3_D",
  "CREATE_SOUND_EFFECT",
  "CREATE_SPEECH",
  "CREATE_VIDEO",
  "PROMPT_EDIT_IMAGE",
  "PROMPT_EDIT_VIDEO",
  "REALTIME",
  "REFRAME_IMAGE",
  "REFRAME_VIDEO",
  "REMESH",
  "REMOVE_BACKGROUND",
  "REMOVE_BACKGROUND_VIDEO",
  "RETEXTURE_MESH",
  "RIG_MESH",
  "SEGMENT_MESH",
  "SPLIT_IMAGE_INTO_LAYERS",
  "UPSCALE",
  "UPSCALE_VIDEO",
  "VECTORIZE_IMAGE",
];
export const SESSION_OBJECT_EVENT_TYPE: SessionObjectEventType[] = [
  "CREATED",
  "DELETED",
  "UPDATED",
];
export const SESSION_OBJECT_TYPE_FILTER: SessionObjectTypeFilter[] = [
  "ASSET",
  "FILE",
];
export const SESSION_STATUS: SessionStatus[] = [
  "ACTIVE",
  "ARCHIVED",
  "DELETED",
];
export const SESSION_TEMPLATE_EXPLORE_SECTION: SessionTemplateExploreSection[] =
  [
    "AUDIO_GENERATION",
    "IMAGE_GENERATION",
    "MARKETING",
    "THREE_D_GENERATION",
    "VIDEO_GENERATION",
    "WORKFLOWS",
  ];
export const SESSION_TEMPLATE_STATUS: SessionTemplateStatus[] = [
  "DISABLED",
  "ENABLED",
];
export const SHORTCUT_TARGET_TYPE: ShortcutTargetType[] = [
  "BASE_MODEL",
  "PROJECT",
  "REFERENCE_SET",
  "SESSION",
  "WORKFLOW",
];
export const SKILL_AGENT: SkillAgent[] = [
  "ASSET_GENERATION_AGENT",
  "GAME_ART_DIRECTOR_AGENT",
  "PLAYABLE_GENERATION_AGENT",
];
export const SKILL_IMPORT_DROP_CODE: SkillImportDropCode[] = [
  "ALLOWED_TOOLS_NOT_SUPPORTED",
  "DOCUMENT_TOO_LONG",
  "DUPLICATE_PATH",
  "RESOURCE_TOO_LARGE",
  "SCRIPTS_NOT_SUPPORTED",
  "TOO_MANY_RESOURCES",
  "UNEXPECTED_ENTRY",
  "UNKNOWN_FRONTMATTER_KEY",
  "UNSUPPORTED_ASSET_TYPE",
  "UNSUPPORTED_PATH",
];
export const SKILL_LOADING_MODE: SkillLoadingMode[] = [
  "ALWAYS",
  "DESCRIPTION",
  "MANUAL",
];
export const SKILL_RESOURCE_KIND: SkillResourceKind[] = ["ASSET", "REFERENCE"];
export const SKILL_SCOPE_SOURCE: SkillScopeSource[] = [
  "PROJECT",
  "REFERENCE_SET",
  "SESSION",
  "WORKSPACE",
];
export const SKILL_STATUS: SkillStatus[] = [
  "FAILED_PROCESSING",
  "PENDING",
  "PROCESSED",
  "UPLOADED",
];
export const SORTING_DIRECTION: SortingDirection[] = ["ASC", "DESC"];
export const SOURCE_TYPE: SourceType[] = [
  "COMPOSITE",
  "MASK",
  "POSE",
  "REFERENCE",
  "SKILL_RESOURCE",
  "TRANSFORMED_REFERENCE",
];
export const SSO_CONNECTION_STATUS: SsoConnectionStatus[] = [
  "ACTIVE",
  "FAILED",
  "PENDING_SETUP",
];
export const SSO_CONNECTION_STRATEGY: SsoConnectionStrategy[] = [
  "ADFS",
  "GOOGLE_APPS",
  "OIDC",
  "OKTA",
  "PINGFEDERATE",
  "SAMLP",
  "WAAD",
];
export const STYLE_AUTO_POPULATION_ATTRIBUTE: StyleAutoPopulationAttribute[] = [
  "CATEGORY",
  "DESCRIPTION",
  "EVALUATION_PROMPTS",
  "IMAGE_CAPTIONS",
  "INPUT_FILE_TYPES",
  "LABELS",
  "NAME",
  "PROMPT_SUFFIX",
];
export const STYLE_CAN_FORGE_FROM_STATUS: StyleCanForgeFromStatus[] = [
  "NO_CUSTOM_STYLE_ON_FREE_TIER",
  "NO_STYLE_IMPORT_PERMISSION",
  "NO_WORKSPACE_BLOCKS_IMPORTS",
  "NO_WORKSPACE_LINK_MISSING",
  "YES",
];
export const STYLE_CATEGORY: StyleCategory[] = [
  "ANIMATION",
  "CHARACTER",
  "EFFECT",
  "GENERAL",
  "OBJECT",
  "SCENE",
];
export const STYLE_CONTENT_TYPE: StyleContentType[] = [
  "BACKGROUND",
  "CHARACTER_MULTI",
  "CHARACTER_SINGLE",
  "ICONS_SYMBOLS",
  "ITEMS_ENVIRONMENT",
  "ITEMS_IN_GAME",
  "OTHER",
  "UI_ELEMENTS",
  "VEHICLES",
];
export const STYLE_FINETUNE_STATUS: StyleFinetuneStatus[] = [
  "ARCHIVED",
  "BUILDING",
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "INITIALIZING",
  "NEW",
];
export const STYLE_INPUT_FILE_TYPE: StyleInputFileType[] = [
  "BACK_IMAGE",
  "BOTTOM_IMAGE",
  "FRONT_IMAGE",
  "LEFT_IMAGE",
  "RIGHT_IMAGE",
  "TOP_IMAGE",
];
export const STYLE_STATUS: StyleStatus[] = [
  "ARCHIVED",
  "BUILDING",
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "DRAFT",
  "FAILED",
  "INITIALIZING",
];
export const STYLE_TYPE: StyleType[] = [
  "LAYER_TRAINED_CHECKPOINT",
  "MODEL_URL",
  "UPLOADED_CHECKPOINT",
  "UPLOADED_LORA",
];
export const STYLE_TYPE_FILTER: StyleTypeFilter[] = [
  "BASE_MODEL",
  "LAYER",
  "WORKSPACE",
];
export const THINKING_LEVEL: ThinkingLevel[] = ["HIGH", "MINIMAL"];
export const TRAINING_CATEGORY: TrainingCategory[] = [
  "CHARACTER",
  "OBJECT",
  "STYLE",
];
export const TRAINING_FRAMEWORK: TrainingFramework[] = [
  "AI_TOOLKIT",
  "DREAMBOOTH",
  "FAL",
  "KOHYA",
  "STYLE_CLONE",
  "TEXT_TO_MOTION",
  "VIDEO_TO_MOTION",
  "VOICE_CLONE",
  "VOICE_DESIGN",
];
export const TRAINING_METHOD: TrainingMethod[] = [
  "COMFY_WORKFLOW",
  "MODEL_URL",
  "TRAINED_EDIT_LORA",
  "TRAINED_IMAGE_STYLE",
  "TRAINED_LORA",
  "TRAINED_MOTION",
  "TRAINED_VOICE",
  "UPLOADED_LORA",
  "UPLOADED_VOICE_EMBEDDING",
];
export const TRAINING_RUN_STATUS: TrainingRunStatus[] = [
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "INITIALIZING",
  "RUNNING",
];
export const USAGE_LIMIT_PERIOD: UsageLimitPeriod[] = [
  "DAILY",
  "MONTHLY",
  "WEEKLY",
];
export const USAGE_LIMIT_STATUS: UsageLimitStatus[] = ["ACTIVE", "DISABLED"];
export const VECTORIZATION_COLOR_MODE: VectorizationColorMode[] = [
  "BINARY",
  "COLOR",
];
export const VECTORIZATION_MODE: VectorizationMode[] = ["POLYGON", "SPLINE"];
export const VIDEO_CODEC: VideoCodec[] = ["H264", "H265"];
export const VIDEO_EFFECT_TYPE: VideoEffectType[] = [
  "ACTION_RUN",
  "AGENT_REVEAL",
  "ARC",
  "ARC_LEFT",
  "BASEBALL_KICK",
  "BASKETBALL_DUNKS",
  "BOXING",
  "BUCKLE_UP",
  "BUILDING_EXPLOSION",
  "BULLET_TIME",
  "CAR_CHASING",
  "CAR_EXPLOSION",
  "CAR_GRIP",
  "CATCH",
  "CATWALK",
  "CRANE_DOWN",
  "CRANE_OVER_THE_HEAD",
  "CRANE_UP",
  "CRASH_ZOOM_IN",
  "CRASH_ZOOM_OUT",
  "DIRTY_LENS",
  "DISINTEGRATION",
  "DOLLY_IN",
  "DOLLY_LEFT",
  "DOLLY_OUT",
  "DOLLY_RIGHT",
  "DOLLY_ZOOM_IN",
  "DOLLY_ZOOM_OUT",
  "DOUBLE_DOLLY",
  "DOWNHILL_POV",
  "DUTCH_ANGLE",
  "EYES_IN",
  "FACE_PUNCH",
  "FISHEYE",
  "FLYING",
  "FOCUS_CHANGE",
  "FPV_DRONE",
  "GENERAL",
  "GLAM",
  "HANDHELD",
  "HEAD_TRACKING",
  "HYPERLAPSE",
  "INVISIBLE",
  "JIB_DOWN",
  "JIB_UP",
  "KISS",
  "LAZY_SUSAN",
  "LENS_CRACK",
  "LENS_FLARE",
  "LEVITATION",
  "LOW_SHUTTER",
  "MELTING",
  "MOONWALK_LEFT",
  "MOONWALK_RIGHT",
  "MOUTH_IN",
  "OBJECT_POV",
  "ORBIT_360",
  "OVERHEAD",
  "PUSH_TO_GLASS",
  "RAP_FLEX",
  "ROBO_ARM",
  "SET_ON_FIRE",
  "SKATEBOARDING",
  "SKATEBOARD_GLIDE",
  "SKATEBOARD_KICKFLIP",
  "SKATEBOARD_OLLIE",
  "SKATE_CRUISE",
  "SKI_CARVING",
  "SKI_POWDER",
  "SNORRICAM",
  "SNOWBOARD_CARVING",
  "SNOWBOARD_POWDER",
  "SOUL_JUMP",
  "STATIC",
  "SUPER_DOLLY_IN",
  "SUPER_DOLLY_OUT",
  "TENTACLES",
  "THROUGH_OBJECT_IN",
  "THROUGH_OBJECT_OUT",
  "THUNDER_GOD",
  "TILT_DOWN",
  "TILT_UP",
  "TIMELAPSE_HUMAN",
  "TIMELAPSE_LANDSCAPE",
  "TURNING_METAL",
  "WHIP_PAN",
  "WIGGLE",
  "WIND_TO_FACE",
  "YOYO_ZOOM",
  "ZOOM_IN",
  "ZOOM_OUT",
];
export const WORKSPACE_DOMAIN_STATUS: WorkspaceDomainStatus[] = [
  "DELETED",
  "FAILED",
  "PENDING",
  "VERIFIED",
];
export const WORKSPACE_INTEGRATION_PROVIDER: WorkspaceIntegrationProvider[] = [
  "APPLOVIN",
  "CHARTBOOST",
  "GOOGLE_ADS",
  "GOOGLE_DRIVE",
  "META",
  "MIRO",
  "SENSORTOWER",
  "TIKTOK_ADS",
];
export const WORKSPACE_INTEGRATION_SCOPE_TARGET_KIND: WorkspaceIntegrationScopeTargetKind[] =
  ["DRIVE_FOLDER"];
export const WORKSPACE_INTEGRATION_STATUS: WorkspaceIntegrationStatus[] = [
  "ACTIVE",
  "ERROR",
  "EXPIRED",
  "PENDING",
  "REVOKED",
];
export const WORKSPACE_MEMBERSHIP_STATUS: WorkspaceMembershipStatus[] = [
  "ACTIVE",
  "SUSPENDED",
];
export const WORKSPACE_ROLE: WorkspaceRole[] = [
  "ADMIN",
  "ARTIST",
  "ART_DIRECTOR",
  "EDITOR",
  "MEMBER",
  "SETTINGS_ADMIN",
];
export const WORKSPACE_USAGE_GROUP_BY: WorkspaceUsageGroupBy[] = [
  "MEASUREMENT_UNIT",
  "MODALITY",
  "MODE",
  "MODEL_ID",
  "MODIFIER_ID",
  "PRICE_CREATIVE_UNITS",
  "USER_ID",
];
